import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { profile_access_module } from '@app/config/role-name.enum';
import { UserService } from '@app/services/user.service';

@Directive({
  selector: '[appHasAccessModule]'
})
export class HasAccessModuleDirective {

  module: profile_access_module;
  moduleActivate: profile_access_module;
  private isViewVisible: boolean = null;


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) { }

  @Input()
  set appHasAccessModule(module: profile_access_module) {

    this.module = module;

    this.userService.roleBehavior.pipe().subscribe(value => {
      if (value) {
        this.executeLogic();
      }
    })

    this.executeLogic();
  }

  @Input()
  set hasActivateModule(module: profile_access_module) {

    this.moduleActivate = module;

    this.userService.moduleActivateBehavior.pipe().subscribe(() => {
      this.executeLogic();
    })

    this.executeLogic();
  }

  executeLogic() {

    let isActivatedModule: boolean = true;

    if (this.moduleActivate) {
      isActivatedModule = this.userService.hasActivateModule(this.moduleActivate);
    }

    if (this.userService.hasAccessToModule(this.module) && isActivatedModule) {

      if (this.isViewVisible)
        return;

      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isViewVisible = true;
      return;
    }

    if (!this.isViewVisible)
      return;

    this.viewContainer.clear();
    this.isViewVisible = false;
  }
}
